import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { downloadFile } from 'helper';
import { exportPartnerRatingByRealEstateExcel } from '../api';

export function useExportPartnerRatingByRealEstateExcelReport() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const exportPartnerRatingByRealEstateExcelReport = async (
    partnerGuid: string,
    realEstateGuid: string,
    config?: AxiosRequestConfig,
  ) => {
    setLoading(true);

    try {
      downloadFile(
        await exportPartnerRatingByRealEstateExcel(partnerGuid, realEstateGuid, config),
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Отчет по партнеру и ЖК.xlsx',
      );
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, exportPartnerRatingByRealEstateExcelReport };
}
